// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "ContentNotFoundSection-module--wrapper--NSPcD";
export var inner = "ContentNotFoundSection-module--inner--iuNns";
export var text = "ContentNotFoundSection-module--text--D7ZLY";